/**
 * Javascript file for the account activation page.
 * @author Adrian Rebmann, Steffen Schuhmann, Eduardo Parducci
 */

import { activateUser } from "../../../../../api";
export default {
  name: "Activate",
  props: ["hash"],

  /**
   * The vue instance's data object.
   * @property {boolean} sending - Information is currently being processed.
   * @property {boolean} sent - Information has been processed.
   * @property {boolean} error - There has been an error.
   */
  data() {
    return {
      sending: false,
      sent: false,
      error: false
    };
  },

  /**
   * Called after the instance has been mounted. 
   */
  mounted() {},

  /**
   * The vue instance's method declaration.
   */
  methods: {
    /**
     * Activates the account.
     */
    activate() {
      this.sending = true;
      this.sent = false;
      activateUser(this.hash)
        .then(() => {
          window.setTimeout(() => {
            this.sent = true;
            this.sending = false;
            this.$router.push({ name: "Signin" });
          }, 1000);
        })
        .catch(err => {
          this.error = true;
          window.setTimeout(() => {
            this.sent = true;
            this.sending = false;
          }, 1000);
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/app/authentication/signup/activate/activate.js